import React, { useState } from "react";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button, ScrollView } from "devextreme-react";
import UserInfo from "../../UserInfo";
import {
  criarContribuinteDs,
  criarReceitasDs,
  criarSituacaoDividaDs,
} from "../../DataSources";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { LoadIndicator } from "devextreme-react/load-indicator";
import showError from "../../AppServices";
import apiAxios from "../../api-axios";
import notify from "devextreme/ui/notify";

const RelacaoDividaAtiva = () => {
  const [estado, setEstado] = useState({
    id: undefined,
    contribuinteId: undefined,
    receitaId: undefined,
    situacaoId: undefined,
    exercicioInicio: undefined,
    exercicioFim: undefined,
    inscricaoInicio: undefined,
    inscricaoFim: undefined,
    prescricaoInicio: undefined,
    prescricaoFim: undefined,
    natureza: "",
    agenteRecebedorId: undefined,
    incluirSemDocumento: true,
    especialIpaporanga: 0,
    popupContribuinteVisivel: false,
    porSituacao: false,
  });

  const [botao, setBotao] = useState({
    loadIndicatorVisivel: false,
    texto: "Visualizar",
  });

  const contribuinteDs = criarContribuinteDs();
  const contribuinteBoxRef = React.createRef();
  const renderContribuinte = sysCodigoDescricao(
    () => estado.contribuinteId,
    setContribuinteId,
    () => estado._uiNomeContribuinte,
    pesquisarContribuinte
  );

  const receitaOptions = {
    searchEnabled: true,
    dataSource: criarReceitasDs(),
    valueExpr: "id",
    displayExpr: "descricao",
    searchMode: "contains",
    showClearButton: true,
    placeholder: " "
  };

  const situacaoOptions = {
    searchEnabled: true,
    dataSource: criarSituacaoDividaDs(),
    valueExpr: "id",
    displayExpr: "nome",
    searchMode: "contains",
    showClearButton: true,
    placeholder: " "
  };

  const tipoDeNaturezaOptions = {
    editorType: "dxSelectBox",
    searchEnabled: false,
    dataSource: [
      { id: "", descricao: "Todos" },
      { id: "T", descricao: "Dívida ativa tributária" },
      { id: "TN", descricao: "Dívida ativa não tributária" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };

  const selectBoxBoolOptions = {
    editorType: "dxSelectBox",
    searchEnabled: false,
    dataSource: [
      { id: false, descricao: "Não" },
      { id: true, descricao: "Sim" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };

  const especialIpaporangaOptions = {
    editorType: "dxSelectBox",
    searchEnabled: false,
    dataSource: [
      { id: 0, descricao: "Não" },
      { id: 1, descricao: "Completa 448" },
      { id: 2, descricao: "Final 336" },
      { id: 3, descricao: "Inicial 420" },
      { id: 4, descricao: "Diferença 448 para 336" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };

  function setContribuinteId(data) {
    console.log(data);
    let state = {};
    Object.assign(state, estado);
    contribuinteDs
      .load({ filter: [["sequencial", "=", data.value]] })
      .then((result) => {
        if (result.length !== 0) {
          console.log(result);
          if (result[0] === undefined) {
            Object.assign(state, { _uiNomeContribuinte: "" });
          } else {
            Object.assign(state, { _uiNomeContribuinte: result[0].nome });
          }
        } else {
          Object.assign(state, { _uiNomeContribuinte: "" });
        }
        console.log(result);
        setEstado({
          ...state,
          contribuinteId: data.value,
          popupContribuinteVisivel: false,
        });
      })
      .catch((_) => setNomeContribuinteErro());
  }

  function setNomeContribuinteErro() {
    setEstado({ ...estado, _uiNomeContribuinte: "<<ERRO>>" });
  }

  function onContribuinteSelecionadoPesquisa(e) {
    let data = {};
    Object.assign(data, { value: e.row.data.sequencial.toString() });
    setContribuinteId(data);
  }

  function pesquisarContribuinte() {
    contribuinteBoxRef.current.limparFiltro();
    setEstado({ ...estado, popupContribuinteVisivel: true });
  }

  function ok() {
    const request = { ...estado, prefeituraId: UserInfo.getPrefeitura() };
    apiAxios
      .post("/report/relacao_diat", {
        ...request,
        responseType: "blob",
      })
      .then((response) => {
        if (response.data.sucesso) {
          const bin = atob(response.data.report);
          const length = bin.length;
          const arrayBuffer = new ArrayBuffer(length);
          const uintArray = new Uint8Array(arrayBuffer);

          for (let i = 0; i < length; i++) {
            uintArray[i] = bin.charCodeAt(i);
          }

          const fileBlob = new Blob([uintArray], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(fileBlob);

          window.open(fileURL, "_blank");
          return true;
        } else {
          notify("Relatório não encontrado.", "error");
          showError(response.data.erros);
          return false;
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          showError(error.response.data);
        } else {
          showError(error);
        }
      })
      .finally(() => {
        setBotao({
          loadIndicatorVisivel: false,
          texto: "Visualizar PDF",
        });
      });
  }

  return (
    <React.Fragment>
      <div className={"content-block dx-card responsive-paddings"}>
        <Form formData={estado} colCount={2}>
          <GroupItem
            caption="Relatório Relação da Dívida Ativa"
            colSpan={2}
            colCount={3}
          >
            <SimpleItem colSpan={3} component={renderContribuinte}>
              <Label text="Contribuinte" />
            </SimpleItem>
            <SimpleItem
              dataField={"receitaId"}
              editorType={"dxSelectBox"}
              editorOptions={receitaOptions}
              colSpan={3}
            >
              <Label text="Receita" />
            </SimpleItem>
            <SimpleItem
              dataField={"situacaoId"}
              editorType={"dxSelectBox"}
              editorOptions={situacaoOptions}
              colSpan={3}
            >
              <Label text="Situação" />
            </SimpleItem>

            <SimpleItem
              dataField={"natureza"}
              editorType={"dxSelectBox"}
              editorOptions={tipoDeNaturezaOptions}
              colSpan={3}
            >
              <Label text="Natureza" />
            </SimpleItem>

            <SimpleItem
              dataField={"especialIpaporanga"}
              editorType={"dxSelectBox"}
              editorOptions={especialIpaporangaOptions}
              colSpan={3}
            >
              <Label text="Especial Ipaporanga " />
            </SimpleItem>
            <SimpleItem
              dataField={"incluirSemDocumento"}
              editorType={"dxSelectBox"}
              editorOptions={selectBoxBoolOptions}
              colSpan={3}
            >
              <Label text="Incluir sem documento" />
            </SimpleItem>

            <SimpleItem
              dataField={"porSituacao"}
              editorType={"dxSelectBox"}
              editorOptions={selectBoxBoolOptions}
              colSpan={3}
            >
              <Label text="Agrupar por Situação" />
            </SimpleItem>

            <GroupItem caption={"Exercício"}>
              <SimpleItem dataField={"exercicioInicio"} colSpan={1}>
                <Label text="Inicial" />
              </SimpleItem>
              <SimpleItem dataField={"exercicioFim"} colSpan={1}>
                <Label text="Final" />
              </SimpleItem>
            </GroupItem>

            <GroupItem caption={"Data de Inscrição"}>
              <SimpleItem
                dataField={"inscricaoInicio"}
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
                colSpan={1}
              >
                <Label text="Inicial" />
              </SimpleItem>
              <SimpleItem
                dataField={"inscricaoFim"}
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
                colSpan={1}
              >
                <Label text="Final" />
              </SimpleItem>
            </GroupItem>

            <GroupItem caption={"Data de Cancelamento"}>
              <SimpleItem
                dataField={"prescricaoInicio"}
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
                colSpan={1}
              >
                <Label text="Inicial" />
              </SimpleItem>
              <SimpleItem
                dataField={"prescricaoFim"}
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
                colSpan={1}
              >
                <Label text="Final" />
              </SimpleItem>
            </GroupItem>
            
          </GroupItem>
        </Form>
        <div
          style={{
            display: "flex",
            marginTop: "25px",
            justifyContent: "center",
            alignContent: "center",
            justifyItems: "center",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex" }}>
            <Button
              width={120}
              style={{ display: "inline-block", justifyContent: "center" }}
              type="success"
              onClick={() => ok()}
            >
              <LoadIndicator
                className="button-indicator"
                id="small-indicator"
                height={20}
                width={20}
                visible={botao.loadIndicatorVisivel}
                style={{ marginRight: "10px", verticalAlign: "middle" }}
              />
              <span className="dx-button-text">{botao.texto}</span>
            </Button>
          </div>
        </div>
      </div>
      <Popup
        visible={estado.popupContribuinteVisivel}
        onHiding={() =>
          setEstado({ ...estado, popupContribuinteVisivel: false })
        }
        dragEnabled={false}
        closeOnOutsideClick={false}
        showCloseButton={false}
        showTitle={true}
        width={"90%"}
        height={"90%"}
        title="Pesquisar Contribuinte"
      >
        <ScrollView showScrollbar={"always"}>
          <ContribuinteBox
            onSelecionado={onContribuinteSelecionadoPesquisa}
            ref={contribuinteBoxRef}
          />
        </ScrollView>
        <ToolbarItem
          toolbar={"bottom"}
          widget="dxButton"
          location="center"
          options={{
            text: "Fechar",
            type: "default",
            width: 150,
            onClick: () =>
              setEstado({ ...estado, popupContribuinteVisivel: false }),
          }}
        ></ToolbarItem>
      </Popup>
    </React.Fragment>
  );
};

export default RelacaoDividaAtiva;
